import React from "react";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Paper,
  Divider,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Images } from "../../../utils/Images";
import ProfileCampaignSlider from "./ProfileCampaignSlider";

const ProfileView = ({ userData, onEdit, showCampaignSlider = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isBelow1200 = useMediaQuery("(max-width:1199px)");
  const isBelow1023 = useMediaQuery("(max-width:1023px)");
  return (
    <Box>
      <Box
        sx={{
          bgcolor: "white",
          borderRadius: "16px 16px 12px 12px",
          border: " 1px solid #DBE0E5",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Paper elevation={0} sx={{}}>
          <Box
            sx={{
              backgroundColor: "#1D1D1B",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              p: isBelow1200 ? "20px 10px" : "29px 24px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex ",
                gap: isBelow1200 ? "10px" : "20px",
                position: isBelow1200 ? "unset" : "absolute",
                bottom: isBelow1200 ? "0px" : "-14px",
                left: isBelow1200 ? "10px" : "30px",
              }}
            >
              <Avatar
                src={userData.profilePicture || Images.defaultAvatar}
                sx={{
                  width: isBelow1200 ? "44px" : 80,
                  height: isBelow1200 ? "44px" : 80,
                  border: " 3px solid #FFF",
                }}
              />
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#fff",
                    fontSize: isBelow1023 ? "10px" : "14px",
                    mb: "10px",
                    p: "4px 6px",
                    backgroundColor: "rgba(253, 232, 233, 0.20)",
                    borderRadius: "4px",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    width: "fit-content",
                  }}
                >
                  ID {userData.id}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "600",
                    color: "#fff",
                    fontSize: isBelow1200 ? "14px" : "16px   ",
                  }}
                >
                  {userData.name}
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              onClick={onEdit}
              sx={{
                textTransform: "none",
                bgcolor: "#FF5858",
                fontWeight: "500",
                fontSize: isBelow1023 ? "10px" : "12px",
                p: "10px 14px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginLeft: "auto",
              }}
            >
              Edit Profile
              <span>
                <img src={Images.editWhite} />
              </span>
            </Button>
          </Box>

          <Box
            sx={{
              p: isBelow1023 ? "18px 16px" : "34px 20px 20px 20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconSms} alt="" />
                </span>{" "}
                Email
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.email}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconCall} alt="" />
                </span>{" "}
                Phone number
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.phone}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconNote} alt="" />
                </span>{" "}
                {isMobile ? "DOB" : "Date of birth"}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.dob}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconBook} alt="" />
                </span>{" "}
                Passport Number
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.passport}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconCards} alt="" />
                </span>{" "}
                PAN Number
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.pan}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#686866",
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {" "}
                <span
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "30px",
                    backgroundColor: "rgba(232, 232, 232, 0.50)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Images.profileIconSex} alt="" />
                </span>{" "}
                Gender
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: isBelow1023 ? "12px" : "14px",
                  fontWeight: "700",
                  color: "#1D1D1B",
                }}
              >
                {userData.gender}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
              {isMobile && showCampaignSlider && (
          <Box sx={{ mt: 3, width: "100%" }}>
            <ProfileCampaignSlider />
          </Box>
        )}
    </Box>
  );
};

export default ProfileView;
